import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, Stack } from "@mui/material";
import axiosInstance from "../../Api/axios.instance";
import dayjs from "dayjs";

export default function PendingApprovals({
  pendingStaff,
  refreshPending,
  refreshStaff,
}) {
  const [sortedStaff, setSortedStaff] = useState([]);

  const [subjects, setSubjects] = useState([]);

  useEffect(() => {
    axiosInstance
      .get("/subjects")
      .then(({ data }) => setSubjects(data.data || []))
      .catch(console.error);
  }, []);

  useEffect(() => {
    const sorted = [...pendingStaff].sort((a, b) => {
      const desigA = a.Designation?.TeachersDesignationId ?? 999;
      const desigB = b.Designation?.TeachersDesignationId ?? 999;
      return desigA - desigB;
    });
    setSortedStaff(sorted);
  }, [pendingStaff]);

  const formatDate = (date) => {
    if (!date) return "Not Defined";
    return dayjs(date).format("DD-MM-YYYY");
  };

  const _handleApprove = async (row) => {
    try {
      const { status } = await axiosInstance.put(
        `/teachers/${row.SchoolTeachersQId}/approve`,
      );
      if (status === 200) {
        await refreshPending();
        await refreshStaff();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const _handleDisapprove = async (row) => {
    try {
      const { status } = await axiosInstance.delete(
        `/teachers/${row.SchoolTeachersQId}/disapprove`,
      );
      if (status === 200) {
        await refreshPending();
        await refreshStaff();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="pending approvals table">
        <TableHead>
          <TableRow>
            <TableCell align="left">Full Name</TableCell>
            <TableCell align="center">School</TableCell>
            <TableCell align="center">Designation</TableCell>
            <TableCell align="center">Status</TableCell>
            <TableCell align="center">Salary</TableCell>
            <TableCell align="center">Subject</TableCell>
            <TableCell align="center">Joining Date</TableCell>
            <TableCell align="center">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedStaff.length > 0 ? (
            sortedStaff.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.TeacherName || "Not Defined"}</TableCell>
                <TableCell align="center">
                  {row.School?.NameOfSchool || "Not Defined"}
                </TableCell>
                <TableCell align="center">
                  {row.Designation?.TeachersDesignation || "Not Defined"}
                </TableCell>
                <TableCell align="center">
                  <span style={{ color: "#d32f2f", fontWeight: 600 }}>
                    {row.Status || "Not Defined"}
                  </span>
                </TableCell>
                <TableCell align="center">
                  {row.FirstSalary || "Not Defined"}
                </TableCell>
                {/* <TableCell align="center">
                  {row.HiredSubject || "Not Defined"}
                </TableCell> */}
                <TableCell align="center">
                  {subjects.find(
                    (s) =>
                      String(s.ID) === String(row.HiredSubject) ||
                      s.SubjectName === row.HiredSubject,
                  )?.SubjectName || "Not Defined"}
                </TableCell>
                <TableCell align="center">
                  {formatDate(row.DateJoining)}
                </TableCell>
                <TableCell align="right">
                  <Stack direction="row" spacing={1} justifyContent="flex-end">
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => _handleApprove(row)}
                    >
                      Approve
                    </Button>
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      onClick={() => _handleDisapprove(row)}
                    >
                      Disapprove
                    </Button>
                  </Stack>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={6} align="center">
                No pending teachers.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
